angular
  .module('gm.common.filters')
  .filter('gmnCryptoIconUrl', gmnCryptoIconUrlFilter);

function gmnCryptoIconUrlFilter(
  Environment
) {
  'ngInject';

  return (input) => {
    if (!input) {
      return undefined;
    }
    return `${Environment.assetsDomain}assets/images/coins/${input.toLowerCase()}.png`;
  };
}

